import {
  HandleSchema,
  HandlesListResponseSchema,
  ShopsResponseSchema,
  type Handle,
  type HandlesListQueryInput,
  type HandlesListResponse,
  type ShopsResponse,
} from '../contracts/handles';
import type { QueryValue, RequestFn } from './client';

/**
 * Namespace `client.handles` — обёртки над эндпоинтами Блока 4.
 * Контракт: `docs/architecture/api-contracts.md` §3.
 */
export interface HandlesApi {
  list(query: HandlesListQueryInput): Promise<HandlesListResponse>;
  get(globalId: string): Promise<Handle>;
  /**
   * Sensitive: требует JWT (401 для гостя). ADR-0089 §5.3: `city` обязателен —
   * паритет с decor (`decors.shops`). Бэк отдаёт только дилеров этого города с
   * брендом ручки/крючка в `fittingBrands` (CI; «не известно 1/2» → Аги/Век),
   * иначе `{ shops: [] }` (empty-состояние P-021). Список городов — `dealers.cities()`.
   */
  shops(globalId: string, city: string): Promise<ShopsResponse>;
}

export function createHandlesApi(request: RequestFn): HandlesApi {
  return {
    list: (query) =>
      request({
        method: 'GET',
        path: '/api/handles',
        query: queryToParams(query),
        responseSchema: HandlesListResponseSchema,
      }),

    get: (globalId) =>
      request({
        method: 'GET',
        path: `/api/handles/${encodeURIComponent(globalId)}`,
        responseSchema: HandleSchema,
      }),

    shops: (globalId, city) =>
      request({
        method: 'GET',
        path: `/api/handles/${encodeURIComponent(globalId)}/shops`,
        query: { city },
        responseSchema: ShopsResponseSchema,
        auth: true,
      }),
  };
}

function queryToParams(q: HandlesListQueryInput): Record<string, QueryValue> {
  return {
    kind: q.kind,
    // ADR-0076: brands[] сериализуется повторением ключа (как colors/shapes).
    brands: q.brands,
    colors: q.colors,
    shapes: q.shapes,
    mountType: q.mountType,
    cursor: q.cursor,
    limit: q.limit !== undefined ? Number(q.limit) : undefined,
  };
}
